import { render, staticRenderFns } from "./PriceSettingsHome.vue?vue&type=template&id=6b84c3e5&scoped=true&"
import script from "./PriceSettingsHome.vue?vue&type=script&lang=js&"
export * from "./PriceSettingsHome.vue?vue&type=script&lang=js&"
import style0 from "./PriceSettingsHome.vue?vue&type=style&index=0&id=6b84c3e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b84c3e5",
  null
  
)

export default component.exports